import { FC } from "react";
import Picker from "./Picker";
import Content, { ContentNS } from "content/content";

interface FromListPickerProps {
  id: string;
  label?: string;
  error: string | null;
  onChange: (value: string) => void;
  onFocus?: () => void;
  value?: string | null;
  options: PickerOption[];
  placeholder?: string;
}

export interface PickerOption {
  id: string;
  value: string;
}

const FromListPicker: FC<FromListPickerProps> = ({
  id,
  label,
  value,
  error,
  options,
  placeholder,
  onChange,
  onFocus,
}) => {
  const textChecklist = (s: string) =>
    Content.shared.t(s, { ns: ContentNS.checklist });

  const optionsToShow = options.map((option) => (
    <option key={option.id} value={option.id}>
      {option.value}
    </option>
  ));

  return (
    <Picker
      id={id}
      label={label || undefined}
      placeholder={
        placeholder
          ? placeholder
          : textChecklist("question.from-list.please-select")
      }
      value={value}
      options={optionsToShow}
      onChange={onChange}
      error={error}
      onFocus={onFocus}
    />
  );
};

export default FromListPicker;
